module.exports = __webpack_public_path__ + "img/facebook-friends.0e3c5899.png";